<div class="mx-auto max-w-(--breakpoint-2xl)">
@if (usersPage) {
  <app-data-table
    (route)="this.handleRoute($event)"
    [title]="'Contacts'"
    [dataPage]="usersPage"
    [columns]="tableColumns"
    [rowActions]="rowActions">
    <div header class="flex w-full flex-row items-center justify-between gap-3">
      <div class="flex w-full justify-start gap-3">
        <app-text-input [control]="searchControl" [placeholder]="'Search contacts'"></app-text-input>
      </div>
      <div class="flex w-full justify-end">
        @if (canManageContacts) {
          <a routerLink="/contacts/create"
             class="h-12 text-theme-sm shadow-theme-xs inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2.5 font-medium
              text-gray-700 hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200">
            <lucide-icon [name]="PlusIcon"></lucide-icon>
            Add Contact
          </a>
        } @else {
          <button
            class="h-12 text-theme-sm shadow-theme-xs inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-4 py-2.5 font-medium text-gray-400 cursor-not-allowed"
            disabled
            title="Only admins or managers can add contacts">
            <lucide-icon [name]="PlusIcon"></lucide-icon>
            Add Contact
          </button>
        }
      </div>
    </div>
  </app-data-table>
}
</div>

<app-modal
  [title]="'Delete Contact'"
  [content]="'Are you sure you want to delete contact ' + '&quot;' + (contactToDelete?.name || '') + '&quot;' + '? This action cannot be undone.'"
  [show]="isDeleteModalOpen"
  [closeButtonLabel]="'Cancel'"
  [confirmButtonLabel]="'Delete'"
  [processing]="isDeleting"
  (onClose)="closeDeleteModal()"
  (onConfirm)="confirmDelete()"
></app-modal>
